export type LiveRoomContext = { generation: number; slug: string; memberId: string }

export function sameLiveRoomContext(expected: LiveRoomContext, current: LiveRoomContext) {
  return expected.generation === current.generation
    && expected.slug === current.slug
    && expected.memberId === current.memberId
}

// The snapshot, poll and send response can all include the same persisted ID.
// Incoming server reaction state is authoritative, including false on removal.
export function mergeLiveMessages<T extends { id: string }>(
  current: T[],
  incoming: T[],
  removedIds: Iterable<string> = [],
): T[] {
  const removed = new Set(removedIds)
  const merged = new Map(current.filter((message) => !removed.has(message.id)).map((message) => [message.id, message]))
  for (const message of incoming) {
    if (!removed.has(message.id)) merged.set(message.id, { ...merged.get(message.id), ...message })
  }
  return [...merged.values()]
}
